import React, { useState } from "react";

export default function ReferrerInfo({ data, onChange }) {
  const [referralLetter, setReferralLetter] = useState(
    data?.referral_letter || ""
  );
  const [diagnosisReport, setDiagnosisReport] = useState(
    data?.diagnosis_report || ""
  );

  const handleInputChange = (key, value) => {
    onChange({
      ...data,
      [key]: value,
    });
  };

  const handleFileUpload = (e, setFile, fieldName) => {
    const file = e.target.files[0];
    if (file) {
      setFile(file.name); // Store the file name or file object
      handleInputChange(fieldName, file.name); // Update the formData with the file name
    }
  };

  return (
    <div>
      <h2 className="text-xl font-bold mb-4">Referrer Information</h2>
      <div className="grid grid-cols-2 gap-6">
        {/* Referring Doctor/Clinic Name */}
        <div>
          <label className="block mb-1 font-medium">
            Referring Doctor/Clinic Name
          </label>
          <input
            type="text"
            value={data?.referring_doctor || ""}
            onChange={(e) =>
              handleInputChange("referring_doctor", e.target.value)
            }
            className="w-full border border-gray-300 rounded-md p-2"
            placeholder="Enter Doctor/Clinic Name"
          />
        </div>

        {/* Referring Hospital/Facility Name */}
        <div>
          <label className="block mb-1 font-medium">
            Referring Hospital/Facility Name
          </label>
          <input
            type="text"
            value={data?.referring_hospital || ""}
            onChange={(e) =>
              handleInputChange("referring_hospital", e.target.value)
            }
            className="w-full border border-gray-300 rounded-md p-2"
            placeholder="Enter Hospital/Facility Name"
          />
        </div>

        {/* Referral Letter */}
        <div>
          <label className="block mb-1 font-medium">
            Referral Letter (File Upload)
          </label>
          <input
            type="file"
            accept=".png, .jpg, .jpeg, .pdf"
            onChange={(e) =>
              handleFileUpload(e, setReferralLetter, "referral_letter")
            }
            className="w-full border border-gray-300 rounded-md p-2"
          />
          {referralLetter && (
            <p className="mt-2 text-sm text-gray-600">
              Uploaded File: {referralLetter}
            </p>
          )}
        </div>

        {/* Preliminary Diagnosis Details */}
        <div>
          <label className="block mb-1 font-medium">
            Preliminary Diagnosis Details
          </label>
          <textarea
            value={data?.preliminary_diagnosis_details || ""}
            onChange={(e) =>
              handleInputChange("preliminary_diagnosis_details", e.target.value)
            }
            className="w-full border border-gray-300 rounded-md p-2"
            placeholder="Enter Preliminary Diagnosis Details"
          ></textarea>
        </div>

        {/* Diagnosis Report */}
        <div>
          <label className="block mb-1 font-medium">
            Upload Diagnosis Report
          </label>
          <input
            type="file"
            accept=".png, .jpg, .jpeg, .pdf"
            onChange={(e) =>
              handleFileUpload(e, setDiagnosisReport, "diagnosis_report")
            }
            className="w-full border border-gray-300 rounded-md p-2"
          />
          {diagnosisReport && (
            <p className="mt-2 text-sm text-gray-600">
              Uploaded File: {diagnosisReport}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
